import React, { useEffect } from 'react';
import exitIntent from '../../utils/exitIntent';

const HearingTestExitIntent = () => {
	useEffect(() => {
		// Needs to be full URLs in order to work
		const fullUrlsToExclude = [
			'https://www.hear.com/lossanddamages/',
			'https://www.hear.com/success-lossanddamages/',
			'https://www.hear.com/supplies/',
			'https://www.hear.com/success-supplies/'
		];

		const currentUrl = window.location.href.toLowerCase().replace(/\/$/, '');
		const normalizedFullUrlsToExclude = fullUrlsToExclude.map((url) => url.toLowerCase().replace(/\/$/, ''));

		if (normalizedFullUrlsToExclude.includes(currentUrl)) {
			return;
		}

		const removeExitIntent = exitIntent({
			onExitIntent: () => {
				if (!window.sessionLayer.cookie.get('ExitIntentShown')) {
					window.sessionLayer.cookie.set('ExitIntentShown', 'true', 1.000008);
					document.body.classList.add('is-exit-intent');
				}
			}
		});

		return () => {
			removeExitIntent();
		};
	}, []);

	const handleRedirect = () => {
		const urlParams = document.location.search;

		window.location.href = 'https://www.hear.com/d/hearing_test/' + urlParams;
	};

	const closePopup = () => {
		document.body.classList.remove('is-exit-intent');
	};

	return (
		<div className="c-exit-popup track-exit-intent-hearing-test">
			<div className="c-exit-popup__overlay track-exit-intent-hearing-test-esc" onClick={closePopup}></div>
			<div className="c-exit-popup__content">
				<button
					className="c-exit-popup__esc track-exit-intent-hearing-test-esc"
					type="button"
					title="Close Overlay"
					onClick={closePopup}
				>
					<img
						src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/close-icon.svg"
						className="o-fluid-img"
						alt=""
					/>
				</button>
				<div className="c-exit-popup__grid">
					<div className="c-exit-popup__img">
						<picture>
							<source
								media="(max-width: 899px)"
								srcSet="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/exit-intent/exit-founders-mobile.jpg"
							/>
							<source
								media="(min-width: 900px)"
								srcSet="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/exit-intent/exit-founders-desk.jpg"
							/>
							<img
								className="o-fluid-img"
								src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/exit-intent/exit-founders-desk.jpg"
								alt="hear.com founders"
							/>
						</picture>
					</div>
					<div>
						<p className="c-exit-popup__title">
							Take our <strong>free 2-minute</strong> question-based hearing test!
						</p>
						<p className="c-exit-popup__copy">
							It will help you make an informed decision on treating your hearing loss.
						</p>
						<button
							onClick={handleRedirect}
							className="c-exit-popup__cta track-exit-intent-hearing-test-cta"
						>
							Take the Test
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HearingTestExitIntent;
